import React from 'react'
import styles from './KeyFeatures.module.css'
import Text from '../../../Text'

// Always-visible "Key Features" checklist for the GT-2 cockpit configurator.
// Rendered OUTSIDE the collapsible <Description> so the features are fully
// visible without a "Continue reading" expand. Bullets are brand-red check marks
// and the text is a step smaller (14px) than the regular description bullets
// (16px) so the list stays compact and doesn't push the configurator controls
// down. A span carrying the `strong` mark (e.g. "100% made in the EU") renders
// bold.

function CheckIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  )
}

const blockText = (block) => (block.children || []).map((c) => c.text || '').join('')
const blockIsBold = (block) => (block.children || []).some((c) => (c.marks || []).includes('strong'))

function KeyFeatures({ heading = 'Key Features', items }) {
  if (!items || items.length === 0) return null

  return (
    <div className={styles.wrapper}>
      <div className={styles.headingWrapper}>
        <Text type="heading-6">{heading}</Text>
      </div>
      <ul className={styles.list}>
        {items.map((block, i) => (
          <li className={styles.item} key={block._key || i}>
            <span className={styles.check}><CheckIcon/></span>
            <span className={styles.featureText} style={{ fontWeight: blockIsBold(block) ? 600 : 300 }}>
              {blockText(block)}
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default KeyFeatures
